const _URL = import.meta.env.REACT_APP_API_BASE_URL;

// const url = _URL + "/";

// const url = "https://backend-bv.mtechub.org/api/v1/";
const url = "https://backend.beforevault.com/api/v1/";

// https://beforevault-staging-backend.caprover-testing.mtechub.com
// http://localhost:9001/

export default url;
